export default __webpack_public_path__ + "static/media/03_PurpleAndBlack.526f8189.png";